// Copyright ©️ 2026 eVolve MEP, LLC

import { Stack } from '@mantine/core';

import { AttachmentList } from 'components/Mantine/Attachments/AttachmentList';
import { MobileBasePageHeader } from 'components/Mantine/MobileBasePageHeader';
import type { WorkOrderDetailPageProps } from 'modules/Shop/WorkOrders/WorkOrderDetail/WorkOrderDetailPage';

export const MobileWorkOrderAttachmentsView = ({ workOrder }: WorkOrderDetailPageProps) => (
  <Stack flex={1} mih={0} w="100%" p="md" pb={0} gap="xs">
    <MobileBasePageHeader
      title={workOrder.identifier}
      parentPage={{ title: workOrder.identifier, url: `/work-orders/${workOrder.workOrderId}` }}
      hideGlobalFilters
    />
    <Stack flex={1} style={{ overflowY: 'auto' }} gap="md">
      <AttachmentList workOrderId={workOrder.workOrderId} allowUploads="workOrder" openFullScreenViewer={false} />
    </Stack>
  </Stack>
);
